import { useRef, useCallback } from 'react'

interface VideoPlayerProps {
  src: string
  poster?: string
  autoPlay?: boolean
  controls?: boolean
  className?: string
}

export default function VideoPlayer({
  src,
  poster,
  autoPlay = false,
  controls = true,
  className = '',
}: VideoPlayerProps) {
  const videoRef = useRef<HTMLVideoElement>(null)

  const handleMouseEnter = useCallback(() => {
    if (autoPlay && videoRef.current) {
      videoRef.current.play().catch(() => {})
    }
  }, [autoPlay])

  const handleMouseLeave = useCallback(() => {
    if (autoPlay && videoRef.current) {
      videoRef.current.pause()
      videoRef.current.currentTime = 0
    }
  }, [autoPlay])

  return (
    <video
      ref={videoRef}
      src={src}
      poster={poster}
      controls={controls}
      loop
      muted
      playsInline
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      className={`w-full h-full object-cover ${className}`}
    />
  )
}
